<template>
  <div class="d-flex flex-row">
    <div class="product-image">
      <el-image
        :src="displayImageUrl"
        :fit="'cover'"
        :preview-src-list="[displayImageUrl]"
      >
        <div slot="error" class="image-slot">
          <img src="/image/static/img/nopic.jpg" />
        </div>
      </el-image>
    </div>
    <div class="context-wrapper flex-grow-1">
      <div class="context">
        <div class="context-item">
          <div class="context-item__value price">
            <div class="d-flex align-items-end">
              <span class="mr-4">ITEM NO.</span>
              <span style="font-size: 16px; font-weight: bold">
                {{ productInfo.sampleNo }}
              </span>
            </div>

            <div>
              <span class="quotedPrice">{{ productInfo.ftyPrice }}</span>
              <span>{{ productInfo.ftyCurrencyUnit }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="context">
        <div class="context-item">
          <div class="context-item__label" v-if="productInfo.brandName">
            {{ productInfo.brandName }}
          </div>
          <div
            v-if="productInfo.sampleNameEn"
            class="context-item__value"
            style="color: #101010"
          >
            {{ productInfo.sampleNameEn }}
          </div>
        </div>
        <div class="context-item" v-if="productInfo.sampleSize">
          <div class="context-item__label">
            {{ 'SIZE' }}
          </div>
          <div class="context-item__value">
            {{ productInfo.sampleSize }}
          </div>
        </div>
      </div>
      <div class="context">
        <div class="context-item">
          <div class="context-item__value">
            <p>{{ productInfo.sampleContent }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    devTrackingQuotationNo: { type: String, default: '' },
    tskInfoNo: { type: String, default: '' },
  },
  data() {
    return { productInfo: {} }
  },
  computed: {
    displayImageUrl() {
      const { defaultImageUrl } = this.productInfo
      return defaultImageUrl
        ? this.$osscdn(defaultImageUrl)
        : '/image/static/img/nopic.jpg'
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      this.productInfo = this.tskInfoNo
        ? await this.getTaskProduct()
        : await this.getProduct()
    },
    getTaskProduct() {
      if (!this.tskInfoNo) return {}
      return this.$api
        .customerDevTrackingQuotationProductTaskApi({
          tskInfoNo: this.tskInfoNo,
        })
        .then((res) => res.body || {})
        .catch(() => ({}))
    },
    getProduct() {
      if (!this.devTrackingQuotationNo) return {}
      return this.$api
        .customerDevTrackingQuotationProductApi({
          devTrackingQuotationNo: this.devTrackingQuotationNo,
        })
        .then((res) => res.body || {})
        .catch(() => ({}))
    },
  },
}
</script>
<style lang="scss" scoped>
.product-image {
  width: 337px;
  height: 224px;
  margin-right: 15px;
  .el-image {
    width: 100%;
    height: 100%;
  }
}
.context-wrapper {
  .context {
    border-bottom: 1px solid #efefef;
    padding: 8px 0;
    .context-item {
      margin-bottom: 15px;
      font-size: 14px;
    }
    .context-item:last-child {
      margin-bottom: 0;
    }
    .context-item .context-item__label {
      color: #101010;
      margin-bottom: 8px;
      font-weight: 600;
    }
    .context-item .context-item__label:empty {
      display: none;
    }
    .context-item .context-item__value {
      color: #4f4f4f;
      line-height: 1.6;
      white-space: pre-line;
      word-wrap: break-word;
      word-break: break-all;
    }
    .context-item .context-item__value:empty {
      display: none;
    }
    .context-item .context-item__value p {
      margin-bottom: 6px;
    }
    .context-item .context-item__value p:last-child {
      margin-bottom: 0;
    }
    .context-item .context-item__value.price {
      display: flex;
      justify-content: space-between;
      .quotedPrice {
        color: rgba(40, 167, 69, 1);
        font-size: 20px;
        margin-right: 6px;
      }
    }
    .context-item .context-item__value.features {
      display: flex;
      flex-wrap: wrap;
      .el-image {
        width: calc(calc(100% / 5) - calc(10px * 4 / 5));
        margin-right: 10px;
        margin-top: 10px;
      }
      .el-image:nth-child(-n + 5) {
        margin-top: 0;
      }
      .el-image:nth-child(5n + 5) {
        margin-right: 0;
      }
    }
  }
  .context:first-child {
    padding-top: 0;
  }
  // .context:last-child {
  //   border-bottom: none;
  // }
  .context.show-more {
    padding-bottom: 0;
    .context-item {
      margin-bottom: 0;
    }
    .show_more-btn {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      cursor: pointer;
      span {
        color: rgba(142, 142, 142, 1);
        font-size: 14px;
        margin-right: 4px;
      }
    }
  }
}
</style>
